<template>
  <div class="container-page">
    <div>
      <p class="title-inner">
        {{ pageTitle }}
      </p>
    </div>

    <div>
      <div class="row">
        <div class="col-12">
          <div class="form-group required">
            <ComponentInput
              v-model="item.name"
              mod="rectangular"
              label="Наименование"
              required
              maxLength="250"
              placeholder="Введите наименование"
            />
          </div>
        </div>
      </div>
      <div class="row mt-10">
        <CheckboxInput v-model="item.isActive" label="Запись активна" />
      </div>
    </div>

    <div>
      <ButtonComponent class="mr-8" mod="gradient-bg" @click="save" :disabled="!item.name">Сохранить</ButtonComponent>
      <ButtonComponent mod="gradient-bg" @click="close">Отмена</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';

  import API from '../api/nsi';

  export default {
    name: 'NsiCard',
    components: { CheckboxInput, ComponentInput, ButtonComponent },
    props: {
      pageTitle: String,
      apiRoute: String,
      cardName: String,
      listName: String,
    },
    data() {
      return {
        id: this.$route.params.id,
        item: {},
      };
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        if (this.id > 0) {
          API.find(this.apiRoute, this.id).then((response) => {
            this.item = response.data;
          });
        } else {
          this.item = {
            isActive: true,
          };
        }
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения поля', 'error');
          return;
        }

        API.update(this.apiRoute, this.item)
          .then((response) => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (response && response.data.id) {
              this.$router.push({ name: this.cardName, params: { id: response.data.id, action: 'edit' } });
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({ name: this.listName });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        item: {},
      };
    },
  };
</script>

<style lang="scss" scoped></style>
